/* eslint-disable */
import createIcon from '../createIcon';

const IconExclamationCircleFilled = createIcon({
  name: 'icon-exclamation-circle-filled',
  content: '<path d="M512 64A448 448 0 1 1 512 960 448 448 0 0 1 512 64z m0 627.2A38.4 38.4 0 1 0 512 768a38.4 38.4 0 0 0 0-76.8zM544 256h-64v349.12h64V256z" fill="currentColor"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconExclamationCircleFilled;
